import React, { useEffect } from "react";

import { routes } from "consts";
import { AdminResourceDeleteModal, HeaderWithBreadcrumbs, PageHeader, PageMain } from "components/molecules";
import { useNavigate } from "react-router-dom";
import { PlaceTagApi, placeTagsApi } from "api/placeTagsApi";
import { PaziaButton } from "components/atoms";
import {
  TanTable,
  useFilters,
  usePagination,
  useSorting,
  TanTableColumn,
} from "components/molecules";
import { usePlaceTags } from "api/hooks";
import { useDeleteResourceActions } from "utils/store";

export const PlaceTagsPage = (): JSX.Element | null => {
  const navigate = useNavigate();
  const { setDeleteResource } = useDeleteResourceActions();
  const { searchPhrase, filter } = useFilters();
  const { limit, onPaginationChange, skip, pagination } = usePagination();
  const { sorting, onSortingChange, fieldWithOrder } = useSorting();
  const { isFetching, isLoading, total, placeTags, invalidate } = usePlaceTags(
    skip,
    limit,
    searchPhrase,
    filter,
    fieldWithOrder,
  );

  useEffect(() => {
    invalidate();
  }, [sorting, pagination]);

  const columns = React.useMemo<TanTableColumn<PlaceTagApi>[]>(() => cols, []);

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        headerText="Tagi miejsc"
        headerButton={<PaziaButton type="primary" title="Dodaj +" onClick={() => navigate(routes.PLACE_TAGS_ADD)} />}
        breadcrumbs={[{ title: "Miejsca", path: routes.PLACES }, { title: "Tagi miejsc" }]}
      />
      <TanTable
        data={placeTags}
        columns={columns}
        total={total}
        loading={isLoading}
        fetching={isFetching}
        onPaginationChange={onPaginationChange}
        onSortingChange={onSortingChange}
        onDelete={(x) => setDeleteResource(x.id)}
        pagination={pagination}
        sorting={sorting}
        onRowClick={(x) => navigate(routes.PLACE_TAGS_EDIT(x.id))}
      />
      <AdminResourceDeleteModal
        title="Usuń tag"
        description="Jesteś pewien że chcesz usunąć tag?"
        onSuccessDelete={() => invalidate()}
        deleteAction={placeTagsApi.delete}
      />
    </PageMain>
  );
};

const cols: TanTableColumn<PlaceTagApi>[] = [
  {
    id: "id",
    hideOnMobile: true,
    accessorKey: "id",
    header: "ID",
    enableColumnFilter: false,
    size: 10,
    cell: (info) => info.getValue(),
  },
  {
    id: "name",
    accessorKey: "name",
    header: "Nazwa",
    cell: (info) => info.getValue(),
  },
];
